import sharedDataApi from "../api/sharedDataApi";
import msalInstance from "../app/msal";
import { apiTokenRequest } from "../authConfig";

export const executeCoolCloudOperations = async (actionItem, productData, recipeData, userInput, expiryDays = null, createdBy = null) => {
  console.log('Starting CoolCloud Operations');
  console.log('Data:', { productId: actionItem.ProductId, modelNumber: actionItem.ModelNumber });

  // Use actionItem.State if productData.State is null/undefined
  const currSdState = actionItem.State || productData.State;
  console.log('CoolCloud state:', currSdState);

  try {
    // Get access token from MSAL
    let tokenResponse;
    try {
      tokenResponse = await msalInstance.acquireTokenSilent({
        ...apiTokenRequest,
        account: msalInstance.getAllAccounts()[0],
      });
    } catch (error) {
      tokenResponse = await msalInstance.acquireTokenPopup({
        ...apiTokenRequest,
        account: msalInstance.getAllAccounts()[0],
      });
    }
    
    const enrichedUserInput = {
      ...userInput,
      _metadata: {
        expiryDays: expiryDays ? parseInt(expiryDays, 10) : null,
        createdBy: createdBy
      }
    };

    const params = {
      productInfo: JSON.stringify(productData),
      recipe: JSON.stringify(recipeData),
      userInput: JSON.stringify(enrichedUserInput),
      state: currSdState,
      downloadSd: true,
      accessToken: tokenResponse.accessToken,
    };

    console.log('generateCoolCloudData parameters:', params);

    // Call the lambda function via GraphQL
    const result = await sharedDataApi.generateCoolCloudData(params);

    console.log('CoolCloud Lambda Response:', result);

    // Parse the result — the GraphQL scalar comes back as a JSON string
    let parsedResult = result;
    if (typeof result === 'string') {
      try {
        parsedResult = JSON.parse(result);
      } catch (e) {
        console.warn('Could not parse CoolCloud result as JSON:', result);
      }
    }

    // If the inner API call reported failure, treat it as an error
    if (
      (parsedResult && parsedResult.apiCallResult && parsedResult.apiCallResult.success === false) ||
      (parsedResult && parsedResult.statusCode && parsedResult.statusCode !== 200)
    ) {
      console.error('CoolCloud API call failed:', parsedResult.apiCallResult?.error || parsedResult.message);
      return { error: true, details: parsedResult.apiCallResult?.error || parsedResult.message };
    }

    return parsedResult;
  } catch (error) {
    console.error('Error calling generateCoolCloudData Lambda:', error);
    console.error('Error message:', error?.message);
    console.error('Error details:', JSON.stringify(error, null, 2));
    return { error: true, details: error };
  }
};